/*
Documentation

this page holds all the routes for the site layout

*/


import Article from '../pages/Article';
import Home from '../pages/Home';
import Categories from '../pages/Categories';
import Category from '../pages/Category';
import LegalTerms from '../pages/legal/Terms';

export default [

    
    {
        path: "/article/:_id",
        component: Article,
    },
    {
        path: "/categories",
        component: Categories,
    },
    {
        path: "/categories/:category",
        component: Category,
    },
    {
        path: "/terms",
        component: LegalTerms,
    },

    //must be last
    {
        path: "",
        component: Home,
    },

]